
import * as storyblokRuntime$_67BR29aY3hFLZhj4L1WIROge77wCUELS_6QC9GnLrUg from '/codebuild/output/src2115314467/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as awsAmplifyRuntime$_8AzR2sqXDOsWMJ7iRDUrbDno64Vrnpr0_45_45NxO3jL308 from '/codebuild/output/src2115314467/src/ark/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$_67BR29aY3hFLZhj4L1WIROge77wCUELS_6QC9GnLrUg, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['awsAmplify']: { provider: awsAmplifyRuntime$_8AzR2sqXDOsWMJ7iRDUrbDno64Vrnpr0_45_45NxO3jL308, defaults: {} }
}
        